const CARD_STRING = 'card';
const CARD_CHILDREN_WITH_LINKS = ['a', 'img', 'button', 'svg', 'i', 'path'];
export { CARD_STRING, CARD_CHILDREN_WITH_LINKS };
//# sourceMappingURL=constants.js.map